<script setup>
import FichaResumen from "@/components/FichaResumen";
import { computed } from "vue";
import store from "@/store/index.js";
import diccionariosFichas from "@/components/PreparaDiccionariosFichasResumen";

const varianteSeleccionada = computed(() => store.getters.varianteSeleccionada);
const estadoSeleccionado = computed(() => store.getters.estadoSeleccionado);
const fechaActualizacion = computed(() => store.getters.fechaActualizacion);

const encabezado = computed(() => {
  let titleVariante = "Variantes del virus SARS-CoV-2";
  let titleEdo = " a nivel nacional";
  if (varianteSeleccionada.value !== "VTODAS") {
    titleVariante =
      diccionariosFichas[estadoSeleccionado.value].variantes[varianteSeleccionada.value].title;
    titleVariante = `Variantes de  ${titleVariante}`;
  }
  if (estadoSeleccionado.value !== "00") {
    titleEdo = diccionariosFichas[estadoSeleccionado.value].nom_edo;
    titleEdo = ` en ${titleEdo}`;
  }
  return titleVariante + titleEdo;
});

const informacionFichas = computed(() => {
  const diccionarioVariantes = { ...diccionariosFichas[estadoSeleccionado.value] };

  if (varianteSeleccionada.value !== "VTODAS") {
    const varianteActual = diccionarioVariantes.variantes[varianteSeleccionada.value];
    diccionarioVariantes.variantes = {};
    diccionarioVariantes.variantes[varianteSeleccionada.value] = varianteActual;
  }
  return diccionarioVariantes;
});
</script>

<template>
  <div class="fichas-variantes">
    <div class="fichas-header card">
      <h3 class="ficha-titulo">{{ encabezado }}</h3>
      <p class="fecha-actualizacion">Última actualización: {{ fechaActualizacion }}</p>
      <p class="m-t-1">
        La distribución de variantes que se presenta a continuación es con base en las muestras
        secuenciadas acumuladas hasta la fecha de actualización. Se presentan las cinco variantes de
        mayor frecuencia, sin embargo la tabla anexa contiene la totalidad de las variantes.
      </p>
    </div>

    <FichaResumen
      v-for="(variante, key) in informacionFichas.variantes"
      :key="`ficha_resumen_${key}`"
      :idVariante="key"
      :titulo="variante.title"
      :titulo2="variante.title2"
      :color="variante.color"
      :presencia="variante.presencia"
      :cantidad-variantes="variante.oms_conteo_variantes"
      :labels="variante.oms_labels"
      :counts="variante.oms_counts"
      :percents="variante.oms_percents"
      :colores="variante.oms_colores"
      :mostrarPresencia="Boolean(estadoSeleccionado === '00')"
    />
  </div>
</template>

<style lang="scss">
.fichas-variantes {
  .fichas-header {
    display: block;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom: 0;
    font-size: map-get($fuente, "size-notas");
    
    .ficha-titulo {
      font-size: map-get($fuente, "size-primario");
      margin: 0.3rem 0 0 0;
    }

    .fecha-actualizacion {
      font-size: map-get($fuente, "size-notas");
      font-weight: 600;
    }
  }

  .ficha-resumen {
    margin-top: -10px;
    margin-bottom: 0px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;

    &:first-child {
      margin-top: 0px;
    }
    
    &:last-child {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    @media (max-width: map-get($media-queries-limit, "mobile")) {
      padding-bottom: 30px;
      margin-top: -20px;
      &:first-child {
        margin-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
        border-bottom-right-radius: 10px;
      }
    }
  }
}
</style>
